<template>
  <div class="flex min-h-screen relative justify-center bg-gradient-to-b to-white antialiased text-gray-900 h-screen">
    <!-- Web Sidebar -->
    <div class="lg:block md:block hidden">
      <Sidebar/>
    </div>
    <!-- Mobile Option -->
    <div :class="showMobileFilter ? 'block' : 'hidden'">
      <div class="lg:hidden md:hidden overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
        <MobileFilter
        @toggleFilter="toggleFilter"/>
      </div>
    </div>
    <!-- Search bar & content (card) seperator -->
    <div class="flex flex-col items-center py-5 mx-auto">
      <!-- Top section (search & filter button) -->
        <div class="w-full flex flex-col items-center justify-center mb-5 px-10">
          <div class="flex items-center block lg:hidden md:hidden my-2 w-full">
            <button class="w-4/6 bg-red-700 text-white rounded shadow hover:text-gray-300 hover:bg-red-900 py-1 mr-1" @click.prevent="toggleFilter()">Filter</button>
            <button
            @click.prevent="sortList"
            class="w-2/6 bg-red-700 text-white rounded shadow hover:text-gray-300 hover:bg-red-900 py-1">
              <span class="">
                <svg class="h-4 w-4 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                </svg>
              </span>
            </button>
          </div>
          <div class="flex items-center justify-center w-full lg:w-96 md:w-96">
            <div class="flex items-center hidden lg:block md:block my-2">
              <button
              @click.prevent="sortList"
              class="bg-red-700 text-white rounded shadow hover:text-gray-300 hover:bg-red-900 py-1 w-20 mr-3">
                <span class="">
                  <svg class="h-4 w-4 inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" />
                  </svg>
                </span>
              </button>
            </div>

            <div class="flex flex-row items-center">
              <input
              v-model="search"
              class=" border-2 border-gray-300 bg-white rounded h-9 px-5 text-sm focus:outline-none lg:w-4/6 md:w-4/6"
                type="search" name="search" placeholder="Search tenant...">
              <button
              @click.prevent="searchTenants"
              class="bg-red-700 text-white rounded m-1 text-sm font-bold px-2 h-9 md:w-2/6 lg:w-2/6 hover:text-gray-300 hover:bg-red-900">search</button>
            </div>
            <!-- End of Search Bar -->
          </div>
        </div>
        <!-- End of Top Section -->
        <div
        v-if="tenants.hasOwnProperty('results')"
        class="overflow-y-scroll">
          <div
          :class="showMobileFilter ? 'hidden' : 'block' " class="tenant-content flex flex-row flex-wrap p-5 justify-center overflow-y-scroll">
            <Card
            v-for="tenant in tenants.results.data"
            :key="tenant.id"
            :tenant="tenant"/>
          </div>
          <div
          v-if="tenants.results.current_page < tenants.results.last_page"
          class="py-2 flex justify-center mx-auto">
            <button
            class="w-40 text-lg font-bold bg-red-700 text-white rounded shadow hover:text-gray-300 hover:bg-red-900 py-1 mr-1"
            @click.prevent="loadMore"
            >Show More</button>
          </div>
        </div>

        <NotFound
        v-else
        class="tenant-content flex flex-row flex-wrap p-5 justify-center overflow-y-scroll h-screen" />
    <!-- end of search bar & content (card) seperator -->
    </div>
  </div>
</template>

<script>
// import Navbar from '../components/Navbar.vue'
import Sidebar from '../components/Sidebar.vue'
import Card from '../components/Card.vue'
import MobileFilter from '../components/MobileFilter.vue'
import NotFound from '../components/NotFound.vue'

export default {
  name: 'TenantList',
  components: {
    Sidebar,
    Card,
    MobileFilter,
    NotFound
  },
  data () {
    return {
      showFilter: false,
      showMobileFilter: false,
      search: ''
    }
  },
  methods: {
    fetchTenants () {
      this.$store.dispatch('fetchTenants')
    },
    toggleFilter () {
      this.showMobileFilter = !this.showMobileFilter
    },
    searchTenants () {
      const payload = {
        keyword: this.search
      }
      this.$store.dispatch('fetchTenants', payload)
    },
    sortList () {
      const payload = {
        sort: !this.sort,
        id: this.categoryId
      }
      this.$store.dispatch('fetchTenants', payload)
    },
    loadMore () {
      const page = this.page
      const payload = {
        id: this.categoryId,
        page: page + 1,
        sort: this.sort
      }
      console.log(payload.page, 'tenantlist')
      this.$store.dispatch('fetchTenants', payload)
    }
  },
  created () {
    this.fetchTenants()
  },
  computed: {
    tenants () {
      return this.$store.state.tenants
    },
    categories () {
      return this.$store.state.categories
    },
    sort () {
      return this.$store.state.sort
    },
    categoryId () {
      return this.$store.state.categoryId
    },
    page () {
      return this.$store.state.page
    }
  }
}
</script>

<style scoped>
.tenant-content {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.tenant-content::-webkit-scrollbar  {
  display: none;
}
.parent {
  min-width: 100%;
}
</style>
